module.exports = __webpack_public_path__ + "img/weteach.b6401092.png";